import Dialogs from "./Dialogs";
import Image from "./Image";
import Link from "./Link";
import Option from "./Option";
import InfoContainer from "./InfoContainer";
import PageLoader from "./PageLoader";
import ProgressBar from "./ProgressBar";
import ErrorPage from "./ErrorPage";
import AsideMenu from "./Specifics/AsideMenu";

const Components = {
    Dialogs: Dialogs,
    Image: Image,
    InfoContainer: InfoContainer,
    Link: Link,
    Option: Option,
    PageLoader: PageLoader,
    ProgressBar: ProgressBar,
    ErrorPage: ErrorPage,
    Specifics: {
        AsideMenu: AsideMenu
    }
};

export default Components;